import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { fetchConsents } from "../../../../Actions/Settings/settingsActions.js";
import DragAndDrop from "./DragAndDrop.js";
import Loader from "../../../../Components/Common/Loader.js";
import { uiNotification } from "../../../../services/UINotificationService.js";
import { PaperworkMenu } from "../components/PaperworkMenu/index.js";
import { PaperworkLayout } from "../components/PaperworkLayout/index.js";
import { pipe } from "../../../../utilities/fp.js";
import { withPermission } from "../../../../hooks/usePermission.js";
import { PERMISSIONS } from "../../../../consts/api.js";
import { PaperworkHeader } from "../components/PaperworkHeader/index.js";
import { PaperworkSearchInput } from "../components/PaperworkSearchInput/index.js";

class Consents extends Component {
  constructor(props) {
    super(props);
    window.scrollTo(0, 0);

    this.state = {
      consents: [],
      consentsPreviewList: [],
      showLoader: false,
    };
  }

  componentDidMount() {
    this.getConsents();
  }

  getConsents = () => {
    this.setState({ showLoader: true });
    this.props
      .fetchConsents()
      .then((response) => {
        this.setState({
          consents: response?.data || [],
          consentsPreviewList: response?.data || [],
        });
      })
      .catch(() => {
        uiNotification.error("Unable to fetch consents. Try again later");
      })
      .finally(() => {
        this.setState({ showLoader: false });
      });
  };

  consentEdit = (id) => {
    this.props.history.push(`/settings/consent/${id}/edit`);
  };

  handleSearch = (searchTerm) => {
    this.setState({
      consentsPreviewList: this.state.consents.filter((c) =>
        String(c.consent_name)
          .toLowerCase()
          .includes(String(searchTerm).toLowerCase()),
      ),
    });
  };

  render() {
    return (
      <PaperworkLayout>
        <PaperworkHeader>
          <div className="d-flex align-center gap-8">
            <PaperworkSearchInput onSearch={this.handleSearch} />
            {this.props.manageConsents.permitted && (
              <Link to="/settings/consent/create" className="new-blue-btn">
                Create Consent
              </Link>
            )}
          </div>
        </PaperworkHeader>
        <PaperworkMenu active="consents" />
        <div className="juvly-section full-width">
          <div className="table-responsive">
            <table className="table-updated setting-table no-td-border no-hover">
              <thead className="table-updated-thead">
                <tr>
                  <th className="col-xs-6 table-updated-th sorting">
                    Consents
                  </th>
                  <th className="col-xs-3 table-updated-th sorting text-left">
                    Added By
                  </th>
                  <th className="col-xs-3 table-updated-th sorting text-left">
                    Actions
                  </th>
                </tr>
              </thead>
              <DragAndDrop
                sortUpdate={this.updateSortOrder}
                list={this.state.consentsPreviewList}
                module={"Consent"}
                editUrl={this.consentEdit}
              />
              <div
                className={
                  this.state.consentsPreviewList
                    ? "no-record no-display"
                    : "no-record"
                }
              ></div>{" "}
              {this.state.consentsPreviewList.length <= 0 &&
                this.state.showLoader === false && (
                  <tbody>
                    <tr>
                      <td colSpan="3" className="table-updated-td">
                        <div className="no-record no-float text-center">
                          Nothing was found.
                        </div>
                      </td>
                    </tr>
                  </tbody>
                )}
            </table>
          </div>
        </div>
        <Loader showLoader={this.state.showLoader} isFullWidth={true} />
      </PaperworkLayout>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ fetchConsents }, dispatch);
}

export default pipe(
  Consents,
  connect(null, mapDispatchToProps),
  withPermission(PERMISSIONS.settings.manageConsents, "manageConsents"),
);
